var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWork = function SvgWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M22.194 22.206h-2.477c-.652 0-1.304.39-1.695 1.043l-1.983 4.274c-.391.782-1.434 1.434-2.608.913-1.042-.522-1.434-1.695-.912-2.608l1.983-4.274c.912-1.956 2.998-3.26 5.215-3.26h.521v-3.128c-.912.39-1.825.521-2.738.521h-3.39c-1.042 0-1.955-.912-1.955-1.955s.913-1.956 1.956-1.956c2.346 0 4.432.13 5.606-.652l1.434-.912c.521-.391 1.303-.522 1.955-.13.652.26 1.043.912 1.043 1.694v8.474c0 1.043-.912 1.956-1.955 1.956m0 0h4.04c.652 0 1.173-.521 1.304-1.173l1.564-11.081c.13-.652.652-1.174 1.304-1.174h.26m-24.77 2.737H1.333m4.563-3.91H1.333m4.563-3.912H1.333m13.82 11.996H1.333v14.08h6.519v-13.95m15.252 6.388v7.562m-4.563-.002h8.474m-12.904-17.99 1.043-3.91m7.039 0a2.933 2.933 0 1 0 0-5.867 2.933 2.933 0 0 0 0 5.867",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgWork;